var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEnvironmentConfig } from 'common';
import { Image } from '../../atoms';
import { useBucketAssetUrl } from '../../hooks';
function InnerBucketImage(_a) {
    var { responsive = true, path, fallbackPath, bucketInstance, getBuildEnv } = _a, rest = __rest(_a, ["responsive", "path", "fallbackPath", "bucketInstance", "getBuildEnv"]);
    const buildEnv = getBuildEnv ? getBuildEnv() : ''; // Note: empty is prod - refer: env-config.ts
    const { srcUrl, fallbackSrcUrl } = useBucketAssetUrl(bucketInstance || 'prod', // Note: defaulting to PROD as we did not mirror everything to lower region
    path, buildEnv, fallbackPath);
    return (_jsx(Image, Object.assign({}, rest, { src: srcUrl, fallbackSrc: fallbackPath ? fallbackSrcUrl : undefined, responsive: responsive })));
}
/**
 * Note:
 * The big why???
 *
 * When `CurrencyIcon`/ CurrencyIdentity UC is used inside RN's FlatList
 * React.Context gets memoized for virtualization reasons on init and the item renderers
 * then does not get access to any of the outer react context unless we make it an expensive render operation
 * by moving some conditional rendering based on context updates to the view in which flatlist is used
 *
 * This meant a whole lot had to change to start using <MarketList /> component
 * per ticket SH-13304 where we decided to conditionally render the FlatList on lower viewports
 *
 * This hackery/ jumping the hook is to prevent rendering errors that we saw when we implemented this feature
 * Error in question is along the lines of:
 * `ConfigContext is undefined` due to usage of `useBucketAssetUrl` which then refered to `useEnvironmentConfig` internally
 */
function BucketImageWithSelfDeterminedEnvironmentConfig(props) {
    const { REACT_APP_BUILD_ENV } = useEnvironmentConfig();
    return (_jsx(InnerBucketImage, Object.assign({}, props, { getBuildEnv: () => REACT_APP_BUILD_ENV })));
}
export function BucketImage(props) {
    if (props.getBuildEnv) {
        return _jsx(InnerBucketImage, Object.assign({}, props));
    }
    return _jsx(BucketImageWithSelfDeterminedEnvironmentConfig, Object.assign({}, props));
}
